// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const BIRTHDATE_PATTERN = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;

export function validateCustomerBirthdate(birthdateValue: string): ?UserInputValidationError {
  if (!birthdateValue || birthdateValue.trim() === '')
    return { id: 'empty' };
  else if (!BIRTHDATE_PATTERN.test(birthdateValue.toLowerCase()))
    return { id: 'invalid-customer-birthdate'};
}
